import React from 'react';

import StepWizard, {
  type StepWizardChildProps,
  type StepWizardProps,
} from 'react-step-wizard';

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@cfa/react-components';

export type StepWizardInstance = Pick<
  StepWizardChildProps,
  'firstStep' | 'lastStep' | 'nextStep' | 'previousStep' | 'goToStep'
>;

export interface StepData {
  isDisabledButtonNext: boolean;
  labelButtonDeny: string;
  labelButtonNext: string;
  onClickBack: () => void;
  onClickNext: () => void;
  ContentData: () => React.ReactNode;
}

interface StepWizardPopUpProps {
  setStepIndex: (step: number) => void;
  initialStep: number;
  open: boolean;
  closePopup: () => void;
  step: StepData;
  setStepWizard: (instance: StepWizardInstance) => void;
  steps: Record<string, StepData>;
  dataTestId?: string;
  className?: string;
}

const StepWizardPopUp: React.FC<StepWizardPopUpProps> = ({
  setStepIndex,
  initialStep,
  open,
  closePopup,
  step,
  setStepWizard,
  steps,
  dataTestId = 'StepWizardPopUp',
  className,
}) => (
  <Modal
    className={className}
    data-testid={dataTestId}
    onClose={closePopup}
    show={open}
    size="md"
  >
    {/* @ts-expect-error ModalHeader props mismatch with Modal context */}
    <ModalHeader></ModalHeader>
    <StepWizard
      initialStep={initialStep}
      instance={
        setStepWizard as unknown as NonNullable<StepWizardProps['instance']>
      }
      onStepChange={({ activeStep }) => setStepIndex(activeStep)}
      transitions={{
        enterRight: '',
        enterLeft: '',
        exitRight: '',
        exitLeft: '',
      }}
    >
      {Object.keys(steps).map((key, idx) => (
        <React.Fragment key={idx}>
          <ModalBody>{steps[key]?.ContentData()}</ModalBody>
        </React.Fragment>
      ))}
    </StepWizard>
    <ModalFooter>
      <Button
        color="secondary"
        data-testid="PrimaryConfirmButton"
        onClick={step.onClickBack}
        variant="outlined"
        className="md:flex-1!"
      >
        {step.labelButtonDeny}
      </Button>
      <Button
        color="secondary"
        data-testid="SecondaryConfirmButton"
        disabled={step.isDisabledButtonNext}
        onClick={step.onClickNext}
        variant="filled"
        className="md:flex-1!"
      >
        {step.labelButtonNext}
      </Button>
    </ModalFooter>
  </Modal>
);

export default StepWizardPopUp;
